import React from "react";
import { connect } from "react-redux";
import _ from 'lodash';
import * as types from "../../constants/actionTypes";
import * as msgs from "../../constants/textConstants";
//import HeaderView from "./HeaderView";
import * as d from "../../reducers/domainReducer";
import Logo from "./Logo";
import ActiveUser from "./ActiveUser";
import UsersList from "./UsersList";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import VersionUpdateBanner from "../common/VersionUpdateBanner";
import MyChartProxyButton from './MyChartProxyButton';
import { Button, Divider, LinkText } from "../ecosystem";

/**
 * Page header component.
 * 
 * @returns {any} header.
 */
class Header extends React.Component {
    constructor(props) {
        super(props);
        const { currentPharmacyUser, currentMyChartUser } = this.props;
        this.state = { activeUser: currentPharmacyUser ? currentPharmacyUser : currentMyChartUser, pageScrolledClass: "" };
        this.throttle = _.throttle(this.handleScroll.bind(this), 150, { maxWait: 100 });
        this.onPrimaryUserSelected = this.onPrimaryUserSelected.bind(this);
        this.onMyChartUserSelected = this.onMyChartUserSelected.bind(this);
        this.onPharmacyUserSelected = this.onPharmacyUserSelected.bind(this);
    }

    componentDidMount() {
        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (!this.props.stayOnIncompleteForm && window.userToSwitch && this.callback) {
                this.callback(window.userToSwitch, this);
                this.callback = null;
            }
            this.props.resetStayOnIncompleteForm();
        });

        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.throttle);
            window.addEventListener('resize', this.resizeThrottle);
        }

        logUI("UI.Header.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.throttle);
        }

        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    onPrimaryUserSelected(user) {
        //this.props.markUserToSwitch({ ...user, isPrimary: true });

        // resorting to window.userToSwitch as the reducer falls behind... 
        // especially when checking the state variable of userToSwitch on a Link click behind ConfirmationModal, where it's 
        // particularly consumed with the option that the browser back button is allowed to leave a changing form without confirmation
        window.userToSwitch = { ...user, isPrimary: true };

        this.callback = this.switchToPrimaryUser;
    }

    onMyChartUserSelected(user) {
        //this.props.markUserToSwitch(user);
        window.userToSwitch = { ...user, isPrimary: false };
        this.callback = this.switchToMyChartUser;
    }

    onPharmacyUserSelected(user) {
        //this.props.markUserToSwitch(user);
        window.userToSwitch = { ...user, isPrimary: false };
        this.callback = this.switchToPharmacyUser;
    }

    onFamilyPlanUserSelected(user) {
        //To-do 
    }

    switchToPrimaryUser(user, thisObj) {
        const { rxDown, hasPharmacy, /*switchToPharmacyUser, switchToMyChartUser,*/ bundle, history } = this.props;
        const { activeUser } = this.state;
        if (!rxDown && hasPharmacy && (bundle === 'pharmacy' || history && history.location.pathname.indexOf('/pharmacy') > -1)) {
            this.props.switchToPharmacyUser(user);
        }
        else {
            this.props.switchToMyChartUser(user, 0);
        }
        this.getPatientPhoto();
        logUI("Proxy.PrimaryUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
        thisObj.setState({ activeUser: user });
        window.userToSwitch = null;
    }

    switchToMyChartUser(user, thisObj) {
        const { currentMyChartUser, /*switchToMyChartUser,*/ bundle } = this.props;
        const { activeUser } = this.state;
        if (user !== activeUser || user.externalId !== currentMyChartUser.externalId) {
            this.props.switchToMyChartUser(window.userToSwitch, window.userToSwitch.index ? window.userToSwitch.index : 0);
            this.getPatientPhoto();
            logUI("Proxy.MyChartUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
            thisObj.setState({ activeUser: window.userToSwitch });
            window.userToSwitch = null;
        }
    }

    switchToPharmacyUser(user, thisObj) {
        const { /*switchToPharmacyUser,*/ bundle } = this.props;
        const { activeUser } = this.state;
        this.props.switchToPharmacyUser(user);
        logUI("Proxy.PharmacyUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
        thisObj.setState({ activeUser: window.userToSwitch });
        window.userToSwitch = null;
    }

    handleScroll(event) {
        if (typeof window !== 'undefined') {
            const scrollY = window.pageYOffset;
            const topOffsetHeight = 110; // Height of header plus margin bottom

            if (scrollY > topOffsetHeight) {
                if ((this.state.scrollTop + topOffsetHeight) < scrollY) {
                    this.setState({
                        scrollTop: scrollY,
                        pageScrolledClass: " page-scrolled-down"
                    });
                }
                else if ((this.state.scrollTop - topOffsetHeight) > scrollY) {
                    this.setState({
                        scrollTop: scrollY,
                        pageScrolledClass: " page-scrolled-up"
                    });
                }
            }
            else {
                this.setState({
                    scrollTop: scrollY,
                    pageScrolledClass: ""
                });
            }
        }
    }

    getPatientPhoto() {
        if (window && window.serverData.data.enablePatientPhoto && this.props.hasMyChart) {
            this.props.getPatientPhoto();
        }
    }

    render() {
        const { primaryUser, currentMyChartUser, currentPharmacyUser, dateTimeOffset, hasAAL, history, serverData, hideBannerOnCrash, infoForUpdateMobileNo, onLogoutClick } = this.props;
        const { activeUser } = this.state;
        const patientPhoto = this.props.patientPhoto && this.props.patientPhoto.response ? this.props.patientPhoto.response.data : null;   
        const children = React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                index,
                opacity: this.state.opacity
            });
        });
        //if (!primaryUser) {
        //    return (
        //        <HeaderView loginStatus={loginStatus} onLogoutClick={onLogoutClick} />
        //    );
        //}

        return (
            //<HeaderView
            //    serverData={serverData} loginStatus={loginStatus} proxyListLoading={proxyListLoading}
            //    primaryUser={primaryUser} currentUser={currentUser} users={proxyList}
            //    onUserClick={onUserClick} onLogoutClick={onLogoutClick}
            ///>   
            <React.Fragment>
                <div ref={(el) => (this.header = el)} className={`container-fluid header ` }>
                    <div className="row">
                        <div className="col-12 maxWidth-content header-proxy-dropdown">
                            <div className="row header__main align-items-center">
                                <Logo containerClass="col-3 header__logo" currentPharmacyUser={currentPharmacyUser} />
                                {/*middleSection*/}
                                <div className="col-9 header__active-users">
                                    <div className="active-users-container sign-out__button">
                                        <Button variant="secondary" size="sm" onClick={onLogoutClick}>Sign out</Button>
                                    </div>
                                    <div className="active-users-container sign-out__link">
                                        <LinkText as="button" type="button" onClick={onLogoutClick}>Sign out</LinkText>
                                    </div>
                                    {/* <ActiveUser
                                        containerClass="active-users-container"
                                        dateTimeOffset={dateTimeOffset}
                                        patientPhoto={patientPhoto}
                                    /> */}
                                    {/*<UsersList
                                        primaryUser={primaryUser} activeUser={activeUser}
                                        currentMyChartUser={currentMyChartUser} currentPharmacyUser={currentPharmacyUser}
                                        onMyChartUserSelected={this.onMyChartUserSelected}
                                        onPharmacyUserSelected={this.onPharmacyUserSelected}
                                        onPrimaryUserSelected={this.onPrimaryUserSelected}
                                        onFamilyPlanUserSelected={this.onFamilyPlanUserSelected}
                                    />*/}
                                    {/*serverData.enableMyChartProxyManagement && <MyChartProxyButton onClick={() => { this.props.history.push("/proxymanagement"); }} />*/}
                                </div>
                            </div>
                            {/*<div className="row header__current-users--mobile">
                                <div className="col-12">
                                    <ActiveUser mobileView primaryUser={primaryUser} activeUser={activeUser} patientPhoto={patientPhoto} />
                                </div>
                            </div>*/}
                        </div>
                        
                    </div>
                    <div className="row header__divider">
                        <Divider orientation="horizontal" mTop="none" mBottom="none" mLeft="none" mRight="none" />
                    </div>
                </div>
                
                {children}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        dateTimeOffset: state.domain.dto,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        rxDown: state.common.rxDown,
        hasPharmacy: state.domain.hp,
        history: state.session.history,
        stayOnIncompleteForm: state.common.stayOnIncompleteForm,
        //patientPhoto: state.portal.patientPhoto,
        hasAAL: !state.common.aalDown && state.domain.aal,
        hideBannerOnCrash: state.common.hideBannerOnCrash,
        infoForUpdateMobileNo: state.session.infoForUpdateMobileNo,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        //markUserToSwitch: (user) => dispatch({ type: types.USER_TO_SWITCH, user }),
        resetStayOnIncompleteForm: () => dispatch({ type: types.STAY_ON_INCOMPLETE_FORM, stay: false }),
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        },
        switchToPharmacyUser: (pharmacyUser) => {
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser });
        },
        getPatientPhoto: () => dispatch({ type: types.PATIENT_PHOTO_START }),
        updateShowBanner: () => dispatch({ type: types.GRAPHIC_BANNER_UPDATE }),
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);